// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 14C7 12.8954 7.89543 12 9 12C10.1046 12 11 12.8954 11 14C11 15.1046 10.1046 16 9 16C7.89543 16 7 15.1046 7 14Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 21.9998H1V6.38181L12.4472 0.658203L13.3416 2.44706L6.23607 5.99985H23V21.9998ZM9 10C6.79086 10 5 11.7909 5 14C5 16.2091 6.79086 18 9 18C11.2091 18 13 16.2091 13 14C13 11.7909 11.2091 10 9 10ZM19 11H15V13H19V11ZM19 15H15V17H19V15Z"}}]};

const Radio1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'radio-1-filled',
    ref,
    icon: element,
  },
));

Radio1FilledIcon.displayName = 'Radio1FilledIcon';

export default Radio1FilledIcon;
